export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    meta: { permiso: 'ED218', requiereLogin: true },
    component: () => import('@/febos/aduanas/dashboard/views/Dashboard')
  },
  {
    path: 'aduana/lotes',
    name: 'batchs',
    meta: { permiso: 'ED155', requiereLogin: true },
    component: () => import('@/febos/aduanas/batches/views/Batches')
  },
  {
    path: 'aduana/lotes-en-revision',
    name: 'batchs-review',
    meta: { permiso: 'ED214', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/aduanas/batches/views/Batches')
  },
  {
    path: 'aduana/subastas',
    name: 'auctions',
    meta: { permiso: 'ED156', requiereLogin: true },
    component: () => import('@/febos/aduanas/auctions/views/Auctions')
  },
  {
    path: 'aduana/subastas/:id/history',
    name: 'auctions-history',
    meta: { permiso: 'ED156', requiereLogin: true },
    component: () => import('@/febos/aduanas/auctions/views/AuctionsHistory')
  },
  {
    path: 'aduana/comprobantes',
    name: 'receipts',
    meta: { permiso: 'ED157', requiereLogin: true },
    component: () => import('@/febos/aduanas/receipts/views/Receipts')
  },
  {
    path: 'aduana/lote/crear',
    name: 'pre-issue',
    meta: { permiso: '*', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/aduanas/batches/views/BatchForm')
  },
  {
    path: 'aduana/lote/editar/:id',
    name: 'edit-batch',
    meta: { permiso: '*', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/aduanas/batches/views/BatchForm')
  },
  {
    path: 'administracion/almacenes',
    name: 'manage-ware-houses',
    meta: { permiso: 'ED160', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/aduanas/management/warehouses/views/WareHouses')
  },
  {
    path: 'administracion/adjudicatarios',
    name: 'successful-bidders',
    meta: { permiso: 'ED159', requiereLogin: true },
    component: () => import('@/febos/aduanas/successfulBidder/views/SuccessfulBidders')
  },
  {
    path: 'administracion/entidades',
    name: 'manage-entities',
    meta: { permiso: 'ED161', requiereLogin: true },
    component: () => import('@/febos/aduanas/management/entities/views/Entities')
  },
  {
    path: 'administracion/productos',
    name: 'manage-products',
    meta: { permiso: 'ED215', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/aduanas/management/products/views/Products')
  },
  {
    path: 'factura-electronica/:categoria/:vista',
    name: 'invoice-issued',
    meta: { permiso: 'ED164', requiereLogin: true },
    // component: () => import('@/febos/chile/dte/vistas/emitidos/Todos')
    component: () => import('@/febos/chile/dte/vistas/Documentos')
  }
];
